import React from 'react';
import { Link } from 'react-router-dom';
import { useConversionResults } from '../hooks/useConversionResults/useConversionResults';
import ConversionUrgencyBanner from './ConversionResults/ConversionUrgencyBanner';
import ConversionHeroResults from './ConversionResults/ConversionHeroResults';
import ConversionSampleReportPreview from './ConversionResults/ConversionSampleReportPreview';
import ConversionValueComparison from './ConversionResults/ConversionValueComparison';
import ConversionSocialProof from './ConversionResults/ConversionSocialProof';
import ConversionTrustIndicators from './ConversionResults/ConversionTrustIndicators';
import ConversionTwoPathsSection from './ConversionResults/ConversionTwoPathsSection';
import ConversionFinalCta from './ConversionResults/ConversionFinalCta';

const ConversionOptimizedResults = ({ 
  assessmentData, 
  energyBaseline, 
  potentialSavings = 0,
  onUpgrade 
}) => {
  const {
    testimonials,
    currentTestimonial,
    setCurrentTestimonial,
    showUrgency,
    conservative,
    aggressive,
    paybackMonths
  } = useConversionResults({ energyBaseline, potentialSavings });

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <ConversionUrgencyBanner showUrgency={showUrgency} />

      <ConversionHeroResults
        energyBaseline={energyBaseline}
        conservative={conservative}
        aggressive={aggressive}
        paybackMonths={paybackMonths}
      />

      <ConversionSampleReportPreview
        aggressive={aggressive}
        paybackMonths={paybackMonths}
        onUpgrade={onUpgrade}
      />

      <ConversionValueComparison
        showUrgency={showUrgency}
        paybackMonths={paybackMonths}
        onUpgrade={onUpgrade}
      />

      <ConversionSocialProof
        testimonials={testimonials}
        currentTestimonial={currentTestimonial}
        setCurrentTestimonial={setCurrentTestimonial}
      />

      <ConversionTrustIndicators />

      <ConversionTwoPathsSection onUpgrade={onUpgrade} />

      <ConversionFinalCta conservative={conservative} onUpgrade={onUpgrade} />
    </div>
  );
};

export default ConversionOptimizedResults;